<div>
  <label [for]="field.id" class="bl-label bl-font-weight--800 bl-font-size--14" [class.bl-required]="field.enabled && field.required">{{ field.label }}</label>
  <textarea class="bl-textarea custom_line_height"
  [id]="field.id"
  [attr.aria-describedby]="field.id+'-desc-container sumAmountEntered'"
  [attr.data-automation-id]="field.automationId"
  [(ngModel)]="textAreaValue"
   rows="10" cols="100"
   [placeholder]="field.config.placeholder"
   [maxlength]="maxCharacterCount"
   (blur)="onBlur($event)"
   (focus)="onFocus()"
   (keyup)="countChar()">
  </textarea>
  <div>
    <span id="sumAmountEntered">
      <span>{{totalTextCount}}/{{maxCharacterCount}}</span>
      <span class="bl-screen-reader-only" *ngIf="isFocused" aria-live="polite">{{screenReaderMessage}}</span>
    </span>
  </div>
</div>
